import React from 'react';
import { isHoldingsBreakdownBlock, isPortfolioBlock } from 'venn-utils';
import { blockSettings, showBlockChangesColumn } from 'venn-state';
import { useRecoilValue } from 'recoil';
import { PanelSection } from '../../../PanelSection';
import { ComparisonOrderSubSection } from './subject-input/ComparisonOrderSubSection';

interface ComparisonOrderSectionProps {
  selectedRefId: string;
}

export const ComparisonOrderSection = ({ selectedRefId }: ComparisonOrderSectionProps) => {
  const blockSetting = useRecoilValue(blockSettings(selectedRefId));
  const showChangesColumn = useRecoilValue(showBlockChangesColumn(selectedRefId));

  const showComparisonForHoldings = isHoldingsBreakdownBlock(blockSetting.customBlockType) && showChangesColumn;
  const isPortfolio = isPortfolioBlock(blockSetting.customBlockType);

  if (!selectedRefId || !(isPortfolio || showComparisonForHoldings)) {
    return null;
  }

  return (
    <PanelSection header="Comparison Order" className="qa-comparison-order-section">
      <ComparisonOrderSubSection selectedBlockId={selectedRefId} refreshedStyling />
    </PanelSection>
  );
};
